import { FieldProps, getIn } from 'formik'
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker'
import type { DatePickerProps as MuiDatePickerProps } from '@mui/x-date-pickers/DatePicker'
import moment, { Moment } from 'moment'
import * as React from 'react'

export type DatePickerProps = FieldProps &
  Omit<MuiDatePickerProps<Moment>, 'name' | 'value' | 'onChange'> & {
    onDateChange?: (date: Date | undefined) => void
  }

export const fieldToDatePicker = ({
  field,
  form,
  disabled = false,
  onDateChange,
  ...props
}: DatePickerProps) => {
  const { name } = field
  const { touched, errors, isSubmitting } = form
  const fieldError = getIn(errors, name)
  const showError = getIn(touched, name) && !!fieldError

  const newOnChange = (newValue: Moment | null) => {
    const dateValue = newValue ? newValue.startOf('day').toDate() : undefined
    form.setFieldValue(name, dateValue)
    onDateChange?.(dateValue)
  }

  const existingTextFieldProps =
    props.slotProps?.textField && typeof props.slotProps.textField !== 'function'
      ? props.slotProps.textField
      : {}

  const existingHelperText = (existingTextFieldProps as any)?.helperText

  return {
    ...props,
    disabled: isSubmitting || disabled,
    onChange: newOnChange,
    value: field.value ? moment(field.value) : null,
    slotProps: {
      ...props.slotProps,
      textField: {
        ...existingTextFieldProps,
        error: showError,
        helperText: showError ? fieldError : existingHelperText,
        name: field.name,
        onBlur: field.onBlur,
        variant: (props as any).variant || existingTextFieldProps.variant,
        InputLabelProps:
          (props as any).InputLabelProps || existingTextFieldProps.InputLabelProps,
      },
    },
  }
}

export const DatePicker: React.ComponentType<DatePickerProps> = (
  props: DatePickerProps
) => <MuiDatePicker {...fieldToDatePicker(props)} />

DatePicker.displayName = 'FormikMaterialUIDatePicker'
